import React, { useEffect, useState } from "react";
import { arrayMove } from "react-sortable-hoc";
import SortableAnswers from "../../components/sortableAnswers/SortableAnswers";
import { toast } from "react-toastify";

const QuestionAnswersList = ({ question }) => {
  const [answers, setAnswers] = useState([]);

  const loadQuestionAnswers = async () => {
    try {
      const data = { question };
      const response = null;
      setAnswers(response);
    } catch (error) {
      console.log("Error fetching answers:", error);
    }
  };

  useEffect(() => {
    if (question) loadQuestionAnswers();
  }, [question]);

  const answerSort = async (sorted) => {
    try {
      const answer = null;
      if (answer) {
        toast.success("Answer sorted successfully!");
      }
    } catch (error) {
      toast.error(error);
    }
  };

  // Handle sorting
  const onSortEnd = ({ oldIndex, newIndex }) => {
    const sorted = arrayMove(answers, oldIndex, newIndex);

    answerSort(sorted);
    setAnswers(sorted);
  };

  return (
    <>
      <SortableAnswers answers={answers} onSortEnd={onSortEnd} />
    </>
  );
};

export default QuestionAnswersList;
